<template>
	<div class="Rlist_wrap"><!-- Rlist_wrap -->
		<h1><img src="images/tit_zjtt.png"  alt=""/></h1>
		<dl class="Rlist">
			<template v-for="(item,index) in toutiaoList" v-if="index<3">
				<dt><i></i><router-link :to="{ name: 'detail', params: { id: item.id }}">{{item.articletitle}}</router-link></dt>
				<dd>{{item.summary.length>100?item.summary.substring(0,100)+'...':item.summary}}</dd>
			</template>
			<!-- <dt><i></i><a href="">国务院称“双碳”发展要科学有序，从实际出发</a></dt>
			<dd>10月9日，国务院总理李克强主持召开国家能源委会议，部署能源改革发展工作，审议“十四五”现代能源体系规划、能源碳达峰实施方案等。</dd>
			<dt><i></i><a href="">俄乌冲突引发经济动荡，中国应加大保供稳价力度</a></dt>
			<dd>2月24日，俄罗斯总统普京决定在顿巴斯地区发起特别军事行动，乌克兰总统泽连斯基宣布乌克兰全境进入战时状态，俄乌战争正式爆发</dd>
			<dt><i></i><a href="">国内开始强调以最小社会成本获得防疫效果</a></dt>
			<dd>10月11日，国务院副总理孙春兰到中国疾控中心调研时强调，要毫不放松抓好外防输入、内防反弹，不断完善防控政策措施，以最小的社会成本获得最大的防控成效。</dd> -->
		</dl>
	</div><!-- /Rlist_wrap -->
</template>

<script>
	export default {
		data() {
			return {
				toutiaoList: [],
			}
		},
		created:function(){
			this.toutiaofnc();
		},
		computed: {
	
		},
		methods: {
			toutiaofnc: function() {
				let _this = this;
				this.$http({
						method: 'get',
						url: 'article/selectArticlesByRecommendTagID',
						responseType: 'json',
						params: {
							tagid: 'df4f4264-bbd5-11ec-84ee-fefcfe218f7c',
							istop: '0',
							pageSize:'3'
						},
					})
					.then(function(response) {
						_this.toutiaoList = response.data.data.data.data;
					})
					.catch(function(error) {
						console.log(error);
					});;
			},
			
		}
	}
</script>

<style>
</style>
